import React from 'react'
import { GoogleLogin } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';
import shareVideo from '../assets/share.mp4';
// import logo from '../assets/logowhite.png';
import logo from '../assets/ishare_white_new.png';
import { client } from '../client';
import jwt_decode from "jwt-decode";

const Login = () => {
  const navigate = useNavigate();

  const onSuccessGoogle = async (credentialResponse) => {
    console.log(credentialResponse);
    const cred = await credentialResponse.credential
    if (cred) {
      const data = await jwt_decode(cred);
      localStorage.setItem('user', JSON.stringify(data));
      const { name, jti, picture } = data;
      const doc = {
        _id: jti,
        _type: 'user',
        userName: name,
        image: picture
      }
  
      client.createIfNotExists(doc)
      .then(() => {
        navigate('/', { replace: true });
      })
    }
  }

  // {
  //   "aud": "302058692354-uusekmat0ghoqa6mcgtkariejt2qev94.ap .googleusercontent.com",
  //   "azp": "302058692354-uusekmat0ghoqa6mcgtkariejt2qev94.apps.googleusercontent.com",
  //   "email": "greatmindsent@gmail.com",
  //   "email_verified": true,
  //   "exp": 1667588650,
  //   "family_name": "Ajavon",
  //   "given_name": "Amah",
  //   "iat": 1667585050,
  //   "iss": "https://accounts.google.com",
  //   "jti": "82d2e254a2996d6ac4f9c14f41cd5b96a94534aa",
  //   "name": "Amah Ajavon",
  //   "nbf": 1667584750,
  //   "picture": "https://lh3.googleusercontent.com/a/ALm5wu1JSLqV4OUFc-Wu4ekgGPUv2LRpR7Gdl08VOU7CvQ=s96-c",
  //   "sub": "117242846337870077313"
  // }


  return (
    <div className='flex justify-start items-center flex-col h-screen'>
      <div className='relative w-full h-full'>
          <video 
            src={shareVideo} 
            type='video/mp4' 
            loop 
            controls={false} 
            muted 
            autoPlay 
            className='w-full h-full object-cover'
          />
          <div className='absolute flex flex-col justify-center items-center top-0 right-0 left-0 bottom-0 bg-blackOverlay'>
            <div className='p-5'>
              <img src={logo} width='210px' alt='logo' />
            </div>

            <div className='shadow-2xl'>
              <GoogleLogin
                onSuccess={onSuccessGoogle}
                onError={() => {
                  console.log('Sorry. Login Failed');
                }}
              />
            </div>

          </div>
      </div>
    </div>
  )
}

export default Login